const config = {
  baseUrl: import.meta.env.VITE_BASE_URL,
  apiUrl: import.meta.env.VITE_API_BASEURL,
  apiKey: import.meta.env.VITE_API_KEY,
  secretKey: import.meta.env.VITE_SECRET_KEY,
  saltKey: import.meta.env.VITE_URL_ENCRYPTION_KEY,
};

export default config;
